(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-marquee-v4"] && !Shopify.designMode) return;
  try {
    
(function(){
  var sec   = document.getElementById('text-marquee-v4-{{ section.id }}');
  if(!sec) return;

  function applySpacer(){
    var isFixed = sec.classList.contains('text-marquee-v4--fixed');
    var spacer  = document.querySelector('.text-marquee-v4__spacer-{{ section.id }}');
    if(!spacer) return;

    if(isFixed){
      // Actual bar height + configured visual gap
      var gap = parseInt(getComputedStyle(sec).getPropertyValue('--tmv4-gap')) || 0;
      var h   = sec.offsetHeight + gap;
      spacer.style.height = (h || parseInt(getComputedStyle(sec).getPropertyValue('--tmv4-spacer-h'))) + 'px';
      spacer.style.display = 'block';
    } else {
      spacer.style.display = 'none';
    }
  }

  applySpacer();
  window.addEventListener('resize', applySpacer);
  document.addEventListener('shopify:section:load', applySpacer);
  document.addEventListener('shopify:section:select', applySpacer);
  document.addEventListener('shopify:section:deselect', applySpacer);
})();

  } catch(e) { console.error(e); }
})();
})();
